import React, { useEffect, useState } from 'react'
import * as R from 'ramda'
import { Subscribe } from 'bey-fix'
import { datadogLogs } from '@datadog/browser-logs'

import NotFound from '../NotFound'
import Spinner from '../Spinner'

import accounts, {
  setActiveApiKey,
  setActiveSudoAccount,
  addToAccountList,
} from '../state/accounts'
import { fetchTenantAccount } from '../helpers/api'

function AccountEnforcer({ accountId, accountList, activeApiKey, children }) {
  const [hasError, setHasError] = useState(false)

  const selectedAccount = R.find(R.propEq('id', accountId))(accountList)
  const selectedApiKey = R.prop('apiKey')(selectedAccount)
  const angelApiKey = R.pipe(
    R.find(R.propEq('role', 'angel')),
    R.prop('apiKey')
  )(accountList)

  useEffect(() => {
    async function _setAccount() {
      try {
        setHasError(false)
        if (selectedApiKey) {
          setActiveApiKey(selectedApiKey)
          setActiveSudoAccount(null)
        } else if (selectedAccount && angelApiKey) {
          setActiveSudoAccount(selectedAccount.id)
          setActiveApiKey(angelApiKey)
        } else if (angelApiKey) {
          const accountToAdd = await fetchTenantAccount({ id: accountId })
          setActiveSudoAccount(accountToAdd.id)
          setActiveApiKey(angelApiKey)
          addToAccountList({
            apiKey: null,
            ...accountToAdd,
          })
        } else if (accountId !== 'demo') {
          // Show an error in demo mode if a non-demo account is accessed
          throw new Error('404 – Not Found')
        }
        datadogLogs.logger.info('AccountEnforcer: Switched account')
      } catch (error) {
        setHasError(true)
        // 404 errors are already logged by the NotFound component
        if (/404/.test(error.message) === false) {
          datadogLogs.logger.error(`AccountEnforcer: ${error.message}`)
        }
      }
    }

    _setAccount()
  }, [accountId, selectedAccount, selectedApiKey, angelApiKey])

  if (hasError) {
    return <NotFound>Kontoen {accountId} kan ikke findes.</NotFound>
  } else if (accountId !== 'demo' && !activeApiKey) {
    return <Spinner className="mv4" />
  }
  return children
}

export default function SubscribedAccountEnforcer(props) {
  return (
    <Subscribe to={accounts}>
      {(accounts) => (
        <AccountEnforcer
          accountList={accounts.accountList}
          activeApiKey={accounts.activeApiKey}
          {...props}
        />
      )}
    </Subscribe>
  )
}
